<template>
  <div id="excel-presupuestos-ejercicio">
    <custom-button
      label="PRESUPUESTO"
      iconText="fa-file-excel"
      tipo="agregar"
      class="mr-2"
      :loading="estaCargando"
      @click="mixGenerarExcel(crearExcelExpedientes)">
    </custom-button>
  </div>
</template>

<script>
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
import CustomButton from '@/components/buttons/Button.vue';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 2;
// const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 1;

export default {
  name: 'ExcelPresupuestoEjercicio',
  mixins: [mixGenerarExceles],
  props: {
    presupuestos: {
      type: Array,
      required: true,
    },
    ejercicio: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      estaCargando: false,
      nombreDocumento: `PRESUPUESTO EJERCICIO ${this.ejercicio}`,
      configuracionExcel: {},
      contrato: {
        numero: '',
      },
      filaTitulos: 2,
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
        },
      },
      // Datos de los encabezados que apareceran en el excel.
      headersColumnas: [
        // {
        //   value: 'Ejercicio', nombreColumna: 'ejercicio', orden: 1,
        // },
        {
          value: 'Fondo', nombreColumna: 'fondo', orden: 1,
        },
        {
          value: 'Clave', nombreColumna: 'clave', orden: 2,
        },
        {
          value: 'Obra', nombreColumna: 'obra', orden: 3,
        },
        {
          value: 'Ppto. Autorizado', nombreColumna: 'pptoAutorizado', orden: 4,
        },
        {
          value: 'Ampliaciones', nombreColumna: 'ampliaciones', orden: 5,
        },
        {
          value: 'Reducciones', nombreColumna: 'reducciones', orden: 6,
        },
        {
          value: 'Ppto. Modificado', nombreColumna: 'pptoModificado', orden: 7,
        },
      ],
      noData: [{
        fondo: '',
        clave: '',
        obra: '',
        pptoAutorizado: '',
        ampliaciones: '',
        reducciones: '',
        pptoModificado: '',
      }],
    };
  },
  methods: {
  },
  computed: {
    getHeaders() {
      const headers = this.headersColumnas
        .map((header) => header.value)
        .sort((a, b) => a.orden - b.orden);
      return headers;
    },
    getColumnas() {
      const columnas = this.headersColumnas
        .map((columna) => columna.nombreColumna)
        .sort((a, b) => a.orden - b.orden);
      return columnas;
    },
    crearDatosDocumento() {
      return [
        {
          value: `PRESUPUESTO EJERCICIO ${this.ejercicio}`,
          row: 1,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 1,
            col: 7,
          },
        },
      ];
    },
    getDetalles() {
      const ppto = JSON.parse(JSON.stringify(this.presupuestos));
      const detalles = [];
      ppto.forEach((item) => {
        item.detalles.forEach((detalle) => {
          const ampliaciones = detalle.modificaciones.filter((elem) => elem.tipo === 'AMPLIACIÓN')
            .reduce((acc, elem) => acc + elem.importe, 0);
          const reducciones = detalle.modificaciones.filter((elem) => elem.tipo === 'REDUCCIÓN')
            .reduce((acc, elem) => acc + elem.importe, 0);
          const pptoModificado = ampliaciones + reducciones + detalle.importe;
          const data = {
            fondo: item.fuente.nombre,
            clave: detalle.claveObra,
            obra: detalle.obra.meta,
            pptoAutorizado: {
              value: detalle.importe,
              estilo: {
                numberFormat: '$#,##0.00',
              },
            },
            ampliaciones: {
              value: ampliaciones,
              estilo: {
                numberFormat: '$#,##0.00',
              },
            },
            reducciones: {
              value: reducciones,
              estilo: {
                numberFormat: '$#,##0.00',
              },
            },
            pptoModificado: {
              value: pptoModificado,
              estilo: {
                numberFormat: '$#,##0.00',
              },
            },
          };
          detalles.push(data);
        });
      });
      return detalles;
    },
    crearExcelExpedientes() {
      // const expedientesExcel = this.getExpedientesParaExcel;
      const datosDocumento = this.crearDatosDocumento;
      const dataHeaders = this.getHeaders;
      // Se agregan totales para cantidad e importe a nombres de columnas.
      const nombreDeColumnas = [...this.getColumnas];
      const bodyData = this.getDetalles.length > 0 ? this.getDetalles : this.noData;
      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            // logos: [...this.logoDocumento],
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            filaInicio: filaInicioDatos,
            data: bodyData,
          },
        },
      };
      return data;
    },
  },
};
</script>

<style>
</style>
